import { type VariantProps } from "class-variance-authority";
import { createContext, use } from "react";

import { type rootStyles } from "./style";

export const CheckboxRootContext = createContext<Partial<VariantProps<typeof rootStyles>> & { disabled?: boolean }>({});

export const useCheckboxRootContext = () => use(CheckboxRootContext);
